import { DISTRIBUTOR_TYPES, MAP_DEFAULT_VIEWPORT } from "./constants";
import translator from "../components/localization/translator";

export const defaultViewport = [MAP_DEFAULT_VIEWPORT.lat, MAP_DEFAULT_VIEWPORT.lng];

export const DEFAULT_DISTRIBUTOR = {
    _id: "",
    name: translator.translate("_all_"),
};

export const vehicleKeyByType = {
    [DISTRIBUTOR_TYPES.CAR.id]: "Car",
    [DISTRIBUTOR_TYPES.BIKE.id]: "Bicycle",
    [DISTRIBUTOR_TYPES.MOTOBIKE.id]: "Moped",
    [DISTRIBUTOR_TYPES.SCOOTER.id]: "SelfRounded",
    [DISTRIBUTOR_TYPES.SELF_ROUNDED.id]: "Pedestrian",
};

// Letter corresponding to vehicleType for display in SelectList: (Հ) Name, (Մ) Name etc.
// Adjust letters if needed to match business requirement. Example (Հ) corresponds to Bike (Հեծանիվ).
export const VEHICLE_LETTER_BY_TYPE = {
    [DISTRIBUTOR_TYPES.CAR.id]: "", // Ավտոմեքենա / Մեքենա
    [DISTRIBUTOR_TYPES.MOTOBIKE.id]: "Մ", // Մոտոցիկլ
    [DISTRIBUTOR_TYPES.BIKE.id]: "Հ", // Հեծանիվ
    [DISTRIBUTOR_TYPES.SCOOTER.id]: "Ի",
    [DISTRIBUTOR_TYPES.SELF_ROUNDED.id]: "Ո", // Ոտքով / Հետիոտն (use "Հ" if preferred)
};

export const getVehicleLetter = (vehicleType) => {
    if (vehicleType == null) return "";
    return VEHICLE_LETTER_BY_TYPE[vehicleType] ?? VEHICLE_LETTER_BY_TYPE[Number(vehicleType)] ?? "";
};
